import React from 'react'
import { CommonCalendarButtonUi } from 'common/components/entities/Calendar/calendar-step/ui/common-calendar-button-ui'
import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { FontProps } from 'common/utils/styleUtilsNew'
import useManagement, { selectors } from 'publisher/hooks/useManagement'
import usePayment, {
  selectors as paymentSelectors,
} from 'publisher/hooks/usePayment'
import { PaidCalendarCashOnDeliveryPaymentButton } from './paid-calendar-cash-on-delivery-payment-button'
import { PaidCalendarDLocalPaymentButton } from './paid-calendar-dlocal-payment-button'
import { PaidCalendarFlutterwavePaymentButton } from './paid-calendar-flutterwave-payment-button'
import { PaidCalendarGocardlessPaymentButton } from './paid-calendar-gocardless-payment-button'
import { PaidCalendarMercadoPagoCreditCardPaymentButton } from './paid-calendar-mercado-pago-credit-card-payment-button'
import { PaidCalendarMercadoPagoPixAndBoletoPaymentButton } from './paid-calendar-mercado-pago-pix-and-boleto-payment-button'
import { PaidCalendarMolliePaymentButton } from './paid-calendar-mollie-payment-button'
import { PaidCalendarPaypalPaymentButton } from './paid-calendar-paypal-payment-button'
import { PaidCalendarPaypalRestPaymentButton } from './paid-calendar-paypal-rest-payment-button'
import { PaidCalendarPaystackPaymentButton } from './paid-calendar-paystack-payment-button'
import { PaidCalendarPixAndBoletoPaymentButton } from './paid-calendar-pix-and-boleto-payment-button'
import { PaidCalendarRazorpayPaymentButton } from './paid-calendar-razorpay-payment-button'
import { PaidCalendarSecureAndPayPaymentButton } from './paid-calendar-secure-and-pay-payment-button'
import { PaidCalendarXenditCardPaymentButton } from './paid-calendar-xendit-card-payment-button'
import { PaidCalendarStripeGeneralPaymentButton } from './paid-calendar-stripe-general-payment-button'
import { PaidCalendarStripeCardPaymentButton } from './paid-calendar-stripe-card-payment-button'
import { PaidCalendarStripeBancontactPaymentButton } from './paid-calendar-stripe-bancontact-payment-button'

export interface PaymentButtonProps {
  entity: BookingPaidCalendarInterface
  commonStyles: FontProps
}

export const PaidCalendarPaymentButton = ({
  entity,
  commonStyles,
}: PaymentButtonProps) => {
  const isScreenshotMode = useManagement(selectors.isScreenshotMode)
  const paymentMethod = usePayment(paymentSelectors.getActivePaymentMethod)
  const isVisible = true
  const isSsr = typeof window === 'undefined'
  const isPreview = useManagement(selectors.isPreviewMode)

  if (isScreenshotMode || isSsr || isPreview) {
    return (
      <CommonCalendarButtonUi
        backgroundColor={entity.selectedSlotBackgroundColor}
        onClick={() => null}
        {...commonStyles}
      >
        {entity.formButtonText}
      </CommonCalendarButtonUi>
    )
  }

  if (!isVisible) {
    return <div />
  }
  switch (paymentMethod) {
    case PaymentMethodEnum.PaypalSoap:
      return (
        <PaidCalendarPaypalPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.PaypalRest:
      return (
        <PaidCalendarPaypalRestPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    // https://app.shortcut.com/systeme/story/73336/revert-stripe
    // case PaymentMethodEnum.StripeCard:
    // case PaymentMethodEnum.StripeIDeal:
    // case PaymentMethodEnum.StripeBancontact:
    // case PaymentMethodEnum.StripeKlarna:
    //   return (
    //     <PaidCalendarStripeGeneralPaymentButton
    //       entity={entity}
    //       commonStyles={commonStyles}
    //     />
    //   )
    case PaymentMethodEnum.StripeCard:
      return (
        <PaidCalendarStripeCardPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )

    case PaymentMethodEnum.StripeBancontact:
      return (
        <PaidCalendarStripeBancontactPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.StripeIDeal:
    case PaymentMethodEnum.StripeKlarna:
    case PaymentMethodEnum.StripeMultibanco:
      return (
        <PaidCalendarStripeGeneralPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.DlocalCard:
      return (
        <PaidCalendarDLocalPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.DlocalBoleto:
    case PaymentMethodEnum.DlocalPix:
      return (
        <PaidCalendarPixAndBoletoPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.MercadoPagoCard:
    case PaymentMethodEnum.MercadoPagoBrCard:
    case PaymentMethodEnum.MercadoPagoCoCard:
    case PaymentMethodEnum.MercadoPagoMxCard:
    case PaymentMethodEnum.MercadoPagoArCard:
    case PaymentMethodEnum.MercadoPagoClCard:
      return (
        <PaidCalendarMercadoPagoCreditCardPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.MercadoPagoPix:
    case PaymentMethodEnum.MercadoPagoBoleto:
    case PaymentMethodEnum.MercadoPagoBrPix:
    case PaymentMethodEnum.MercadoPagoBrBoleto:
      return (
        <PaidCalendarMercadoPagoPixAndBoletoPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.RazorpayCard:
      return (
        <PaidCalendarRazorpayPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.Flutterwave:
      return (
        <PaidCalendarFlutterwavePaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.Mollie:
      return (
        <PaidCalendarMolliePaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.Gocardless:
      return (
        <PaidCalendarGocardlessPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.CashOnDelivery:
      return (
        <PaidCalendarCashOnDeliveryPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.XenditIdCard:
    case PaymentMethodEnum.XenditPhCard:
      return (
        <PaidCalendarXenditCardPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.PaystackGhCard:
    case PaymentMethodEnum.PaystackKeCard:
    case PaymentMethodEnum.PaystackNgCard:
    case PaymentMethodEnum.PaystackZaCard:
    case PaymentMethodEnum.PaystackEgCard:
    case PaymentMethodEnum.PaystackCiCard:
      return (
        <PaidCalendarPaystackPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    case PaymentMethodEnum.SecureAndPay:
      return (
        <PaidCalendarSecureAndPayPaymentButton
          entity={entity}
          commonStyles={commonStyles}
        />
      )
    default:
      return <div />
  }
}
